/* eslint-disable */
import Bowser from 'bowser'
import uuid from 'uuid/v4'
import jstz from 'jstz'

const uniqueId = window.localStorage.getItem('uniqueId') || uuid()
window.localStorage.setItem('uniqueId', uniqueId)

export default {
  isEmulator: () => {
    return document.location.hostname == 'localhost'
  },
  
  getUniqueId: () => {
    return uniqueId
  },
  
  info: () => {
    const platform = Bowser.getParser(window.navigator.userAgent).parsedResult
    
    return {
      browser: platform.browser.name,
      browserVersion: platform.browser.version,
      os: platform.os.name,
      osVersion: platform.os.version,
      timezone: jstz.determine().name(),
    }
  }
}